import Modal from 'react-bootstrap/Modal';
import { Col, Container, Row } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import Loader from "./sections/loader"; 
import ContactForm from "./sections/contact-form";




const EnrollModal = (props) => {

 
    return (
        <>
        <Modal show={props.show} centered  size="xl" fullscreen={true} onHide={props.onHide} animation={true}>
        <Modal.Header>
            <Button 
                variant="text" 
                className="close text-white"  
                onClick={props.onHide}
                backgroundColor="transparent"
                color="#ffffff"
                hoverBackgroundColor="transparent"
                padding="0"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M15 5L5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M5 5L15 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </Button>
        </Modal.Header>
        <Modal.Body>


            <div className='text-center'>
                <h1 className="enroll-modal-title">Talk to the Expert for <span className='theme-color-green'>Quality Assured</span> Deliverables</h1>
                <p className="enroll-modal-desc">We deliver excellence from experience. Our services focus on<br className='d-none d-lg-block' /> precision, quality, and proven construction processes.</p>      
            </div>
            
            <Container className='mb-5'>
                <Row>
                   
                    <Col  xl={{ span: 10, offset: 1 }}>
                        <ContactForm />
                    </Col>
                </Row>
            </Container>
            
        </Modal.Body>
        </Modal>


        
        </>
      );
}


export default EnrollModal;